
/* Controls for Cosmos3

groupColors
groupLabels
showAllControls
showNavControls
showTimeControls
showSiteLocationControls
enableLatLongSliders

currentView   "AboveEarth" "Space" "Site"

*/
import AnimateProxyBase from "SATPROF_LIBRARY/DropinSupervisor/animate-proxys/animate-proxy-base";
import AnimateButtonProxy from "SATPROF_LIBRARY/DropinSupervisor/animate-proxys/animate-button-proxy";
import TimingInfo from "SATPROF_LIBRARY/DropinSupervisor/timing-info";
import AnimateRenderSpace from "SATPROF_LIBRARY/DropinSupervisor/render-spaces/animate-render-space";
import UniversalRenderSpace from "SATPROF_LIBRARY/DropinSupervisor/render-spaces/universal-render-space"; 
import UtilSP from "SATPROF_UTILS/UtilSP"; 
import Slider_p from "SATPROF_LIBRARY/Slider/Slider_p"; 
import RadioButtonGroup_p from "SATPROF_LIBRARY/RadioButtonGroup/RadioButtonGroup_p"; 
import VersaButton_p from "SATPROF_LIBRARY/VersaButton/VersaButton_p";

export default class Cosmos3controls_p extends AnimateProxyBase{
 
	private animate_rs:AnimateRenderSpace;
	private universal_rs:UniversalRenderSpace;
	private cosmos3_grp:any; //cosmos3_grp;
 
	private ready:boolean = false;
    private timeSlider_p:Slider_p;
    private _timeSliderValue:number = -1; // Will be fixed in setter
    private siteLong_sldr_p:Slider_p;
    private siteLat_sldr_p:Slider_p;
    
    private spaceEarthButtonGroup_p:RadioButtonGroup_p;
    private lastgroundViewSiderSetting:number;
    private lastspaceViewSiderSetting:number;
    private _currentView:string = "AboveEarth";    // "Space" "Site"
    private _groupColors:Array<string>;
    private _groupLabels:Array<string>;

    public moveRightButton_p:VersaButton_p;
    public moveLeftButton_p:VersaButton_p;
    public moveUpButton_p:VersaButton_p;
    public moveDownButton_p:VersaButton_p;
    public moveForwardButton_p:VersaButton_p;
    public moveBackwardButton_p:VersaButton_p;
    public navTimer:TimingInfo;		
    private _enableLatLongSliders:boolean;

    onFrameZero(){
        //console.log("In Dial.onFrameZero()");
        super.onFrameZero();

       this.animate_rs = this.extraData.animate_rs;
        this.universal_rs = this.extraData.universal_rs;
        this.cosmos3_grp = this.extraData.cosmosGroup;
        //this.stageSymbol.outline_mc.rotation = 20;
        this.initialize();

    }
	public initialize(){

		//console.log("FYI, in Cosmos3controls_p.initialize");
       	this.ready = true;
        this.navTimer = new TimingInfo();


		this.configureNavControls();
		this.configureViewControls();

	    this.lastspaceViewSiderSetting = this.timeSlider_p.value;
        this.currentView = "AboveEarth"; // Use setter
        this.spaceEarthButtonGroup_p.selected = 1;

        this.setTimeSlider(1);

        //Listen for all events dispatched on Window:
        window.addEventListener("BUTTON_DOWN", this.onNavButtonDown.bind(this));  
        window.addEventListener("BUTTON_UP", this.onNavButtonUp.bind(this));  
        window.addEventListener("SLIDERVALUECHANGE", this.onSliderChange.bind(this));
        window.addEventListener("SLIDERMOUSEDOWN", this.onSliderMouseDown.bind(this));
        window.addEventListener("SLIDERMOUSEUP", this.onSliderMouseUp.bind(this));
        window.addEventListener("CLICKEDRADIOBUTTON", this.onRadioButtonClick.bind(this));	

		this.stageSymbol.loading_txt.visible = false;
        //console.log("this.currentView = "+this.currentView);
	}
    onRequestAnimFrame(timingInfo : TimingInfo) {
        // Do every frame
		this.doEveryFrame();
	} 
    public set showNavControls(val:boolean) {
        this.stageSymbol.navControls.visible = val;
    }  
    public get showNavControls() {
        return this.stageSymbol.navControls.visible;
    }      
	public configureNavControls(){
       this.moveRightButton_p = this.getProxy(
            "navControls.moveRight_btn", // stage symbol instance name (display tree path)
            VersaButton_p,   // Class of the proxy to be created
            {animateSpace:this.animate_rs}
        );
        this.moveRightButton_p.name = "moveRight_btn"; // Do this manually so you can tell where events came from
        this.moveRightButton_p.selectable = false;
        this.moveRightButton_p.rolloverText = "Move lookat point";

        this.moveLeftButton_p = this.getProxy(
            "navControls.moveLeft_btn", // stage symbol instance name (display tree path)
            VersaButton_p,   // Class of the proxy to be created
            {animateSpace:this.animate_rs}
        )
        this.moveLeftButton_p.name = "moveLeft_btn"; // Do this manually so you can tell where events came from
        this.moveLeftButton_p.selectable = false;
        this.moveLeftButton_p.rolloverText = "Move lookat point";

        this.moveUpButton_p = this.getProxy(
            "navControls.moveUp_btn", // stage symbol instance name (display tree path)
            VersaButton_p,   // Class of the proxy to be created
           {animateSpace:this.animate_rs}
        );
        this.moveUpButton_p.name = "moveUp_btn"; // Do this manually so you can tell where events came from
        this.moveUpButton_p.selectable = false;
        this.moveUpButton_p.rolloverText = "Move lookat point";

        this.moveDownButton_p = this.getProxy(
            "navControls.moveDown_btn", // stage symbol instance name (display tree path)
            VersaButton_p,   // Class of the proxy to be created
           {animateSpace:this.animate_rs}
        );
        this.moveDownButton_p.name = "moveDown_btn"; // Do this manually so you can tell where events came from
        this.moveDownButton_p.selectable = false;
        this.moveDownButton_p.rolloverText = "Move lookat point";

        this.moveForwardButton_p = this.getProxy(
            "navControls.moveForward_btn", // stage symbol instance name (display tree path)
            VersaButton_p,   // Class of the proxy to be created
           {animateSpace:this.animate_rs}
        );
        this.moveForwardButton_p.name = "moveForward_btn"; // Do this manually so you can tell where events came from
        this.moveForwardButton_p.selectable = false;
        this.moveForwardButton_p.rolloverText = "Move lookat point"; 

        this.moveBackwardButton_p = this.getProxy(
            "navControls.moveBackward_btn", // stage symbol instance name (display tree path)
            VersaButton_p,   // Class of the proxy to be created
           {animateSpace:this.animate_rs}
        );
        this.moveBackwardButton_p.name = "moveBackward_btn"; // Do this manually so you can tell where events came from
        this.moveBackwardButton_p.selectable = false;
        this.moveBackwardButton_p.rolloverText = "Move lookat point";   	
	}	
	public configureViewControls(){
        this.timeSlider_p = this.getProxy(
            "timeControls.timeSlider_mc",  // stage symbol instance name (display tree path)
            Slider_p,   // Class of the proxy to be created
        {animateSpace:this.animate_rs}); // Extra data (not used)
        this.timeSlider_p.name = "timeSlider_mc";
        this.timeSlider_p.trackLength = 700;
        //this.timeSlider_mc.tickInterval = 5;
        this.timeSlider_p.minimum = 0;
        this.timeSlider_p.maximum = 10.2;
        this.timeSlider_p.value = 5;
        this.timeSlider_p.snapInterval = .1;
        this.timeSlider_p.enabled = true;
        this.timeSlider_p.enableWheel = false;

         this.siteLong_sldr_p = this.getProxy(
            "siteLocationControls.siteLong_sldr",  // stage symbol instance name (display tree path)
            Slider_p,   // Class of the proxy to be created
        {animateSpace:this.animate_rs}); // Extra data (not used)
        this.siteLong_sldr_p.name = "siteLong_sldr";
        this.siteLong_sldr_p.trackLength = 700; //360;
        this.siteLong_sldr_p.tickInterval = 10;
        this.siteLong_sldr_p.minimum = -60;///-180;
        this.siteLong_sldr_p.maximum = 60; ///180;
        this.siteLong_sldr_p.value = 0;
        this.siteLong_sldr_p.snapInterval = 1;
        this.siteLong_sldr_p.enabled = true;
        this.siteLong_sldr_p.enableWheel = false;

        this.siteLat_sldr_p = this.getProxy(
            "siteLocationControls.siteLat_sldr",  // stage symbol instance name (display tree path)
            Slider_p,   // Class of the proxy to be created
        {animateSpace:this.animate_rs}); // Extra data (not used)
        this.siteLat_sldr_p.name = "siteLat_sldr";
        this.siteLat_sldr_p.trackLength = this.siteLong_sldr_p.trackLength;
        this.siteLat_sldr_p.tickInterval = 10;
        this.siteLat_sldr_p.minimum = 0; ///-90;
        this.siteLat_sldr_p.maximum = 60; ///90;
        this.siteLat_sldr_p.value = 30;
        this.siteLat_sldr_p.snapInterval = 1;
        this.siteLat_sldr_p.enabled = true;
        this.siteLat_sldr_p.enableWheel = false;

        this.spaceEarthButtonGroup_p = this.getProxy(
        "spaceEarthButtonGroup",  // stage symbol instance name (display tree path)
        RadioButtonGroup_p,   // Class of the proxy to be created
        {animateSpace:this.animate_rs}); // Extra data (not used)
        this.spaceEarthButtonGroup_p.name = "spaceEarthButtonGroup";
        this.spaceEarthButtonGroup_p.labelSide = "right";
        this.spaceEarthButtonGroup_p.setLabelText(0, "Space")
        this.spaceEarthButtonGroup_p.setLabelText(1, "Above earth");
        this.spaceEarthButtonGroup_p.setLabelText(2, "Site");
        this.spaceEarthButtonGroup_p.labelFont = "24px Arial";
        this.spaceEarthButtonGroup_p.labelColor = "white";
        this.spaceEarthButtonGroup_p.selected = 1;
        this.spaceEarthButtonGroup_p.nButtons = 3; // Do this first      
	}

	public reset(){
        // For backwards compatibility for older dropins
        this.resetToDefaultSettings();
    }
	public resetToDefaultSettings(){
        //console.log("In Cosmos3controls_p.resetToDefaultSettings()");
        this.siteLat_sldr_p.value = 30;
        this.siteLong_sldr_p.value = 0;
        this.setTimeSlider(5);
        this.currentView ="AboveEarth"; 	
	}
   
	public doEveryFrame(){
        //console.log("In cosmos3controls.doEveryFrame, this.siteLat_sldr_p.value = "+this.siteLat_sldr_p.value);
        if (this._enableLatLongSliders){
            this.cosmos3_grp.earth.siteLong = this.siteLong_sldr_p.value;
            this.cosmos3_grp.earth.siteLat = this.siteLat_sldr_p.value;
        }

        let k:number;   
        if (this._currentView == "AboveEarth" || this._currentView == "Space"){
                //this.mystage.yValue_txt.text= 
            k = 1000; 
            if (this.moveRightButton_p.buttonIsDown){
                this.universal_rs.uniCamHandler.lookatX += k*this.navTimer.elapsedTime;
                this.navTimer.reset();
            }
            if (this.moveLeftButton_p.buttonIsDown){
                this.universal_rs.uniCamHandler.lookatX -= k*this.navTimer.elapsedTime;
                this.navTimer.reset();
            }
            if (this.moveUpButton_p.buttonIsDown){
                this.universal_rs.uniCamHandler.lookatY += k*this.navTimer.elapsedTime;
                this.navTimer.reset();
            }
            if (this.moveDownButton_p.buttonIsDown){
                this.universal_rs.uniCamHandler.lookatY -= k*this.navTimer.elapsedTime;
                this.navTimer.reset();
            }
            if (this.moveForwardButton_p.buttonIsDown){
                this.universal_rs.uniCamHandler.lookatZ += k*this.navTimer.elapsedTime;
                this.navTimer.reset();
            }
            if (this.moveBackwardButton_p.buttonIsDown){
                this.universal_rs.uniCamHandler.lookatZ -= k*this.navTimer.elapsedTime;
                this.navTimer.reset();
            } //    UtilSP.formatDecimals(this.universal_rs.uniCamHandler.distance-UtilSP.earthRadiuskm,0)+" km";
        } else if (this._currentView == "Site"){
            //this.mystage.yValue_txt.text= Math.floor(this.cosmos3_grp.earth.siteLat) +" deg N";
            k = .1; 
            if (this.moveRightButton_p.buttonIsDown){
                this.universal_rs.uniCamHandler.posX += k*this.navTimer.elapsedTime;
                this.navTimer.reset();
            }
            if (this.moveLeftButton_p.buttonIsDown){
                this.universal_rs.uniCamHandler.posX -= k*this.navTimer.elapsedTime;
                this.navTimer.reset();
            }
            if (this.moveUpButton_p.buttonIsDown){
                this.universal_rs.uniCamHandler.posY += k*this.navTimer.elapsedTime;
                this.navTimer.reset();
            }
            if (this.moveDownButton_p.buttonIsDown){
                this.universal_rs.uniCamHandler.posY -= k*this.navTimer.elapsedTime;
                this.navTimer.reset();
            }
            if (this.moveForwardButton_p.buttonIsDown){
                this.universal_rs.uniCamHandler.posZ += k*this.navTimer.elapsedTime;
                this.navTimer.reset();
            }
            if (this.moveBackwardButton_p.buttonIsDown){
                this.universal_rs.uniCamHandler.posZ -= k*this.navTimer.elapsedTime;
                this.navTimer.reset();
            } //    UtilSP.formatDecimals(this.universal_rs.uniCamHandler.distance-UtilSP.earthRadiuskm,0)+" km";

        }      
        this.cosmos3_grp.doEveryFrame();
        this.stageSymbol.siteLocationControls.siteLat_txt.text = this.cosmos3_grp.earth.siteLat.toFixed(2);
        this.stageSymbol.siteLocationControls.siteLong_txt.text = this.cosmos3_grp.earth.siteLong.toFixed(2);

            	
	}

   


    private onRadioButtonClick(evt){
        //console.log("in onRBclick, evt = "+evt.detail.name+", this.spaceEarthButtonGroup_p.selected = "+this.spaceEarthButtonGroup_p.selected);
        switch(this.spaceEarthButtonGroup_p.selected){
            case 0:
                this.currentView = "Space";
                break;
            case 1:
                this.currentView = "AboveEarth";
                break;
            case 2:
                this.currentView = "Site";
                break;
        }
        //console.log("in onRBclick, now selected = "+this.spaceEarthButtonGroup_p.selected);
    }
    public set currentView(val:string){
        //console.log("In Cosmos3controls_p, set currentView val = "+val+", this._currentView = "+this._currentView);
        if (val == this._currentView){
            //console.log("  No change - returning");
            return;
        }
        //console.log("  Setting this._currentView to "+val);

        let valid:boolean = false;
        switch(val){
            case "Space":
                this.spaceEarthButtonGroup_p.selected = 0;
                valid = true;
                break;
            case "AboveEarth":
                this.spaceEarthButtonGroup_p.selected = 1;
                valid = true;
                break;            
            case "Site":
                this.spaceEarthButtonGroup_p.selected = 2;
                valid = true;
                break;
            default:
                valid = false;
                console.log("In Cosmos3controls_p set currentView, invalid val = "+val)
        }   
        if (valid){
            console.log("In Cosmos3controls_p, throwing event COSMOS3_VIEW_CHANGE "+{detail:{name:"Cosmos3controls_p"}});
            this._currentView = val;
            const event = new CustomEvent('COSMOS3_VIEW_CHANGE', { detail:{name:"Cosmos3controls_p"} });
            window.dispatchEvent(event);          
        }

    }
    public get currentView(){
        return this._currentView;
    }
    private onSliderChange(evt){
        //console.log("in onSliderChange, evt = "+evt.detail.name+", val = "+this.timeSlider_p.value);
        let val:number;
        if (evt.detail.name == "timeSlider_mc"){
            val = this.timeSlider_p.value;
            this.setTimeSlider( val);
            //this.cosmos3_grp.timeAccelFactor = this.timeSlider_p.value;
            //this.setTimeSlider( this.timeSlider_p.value);
        } else if ( this._enableLatLongSliders &&(evt.detail.name == "siteLat_sldr" || evt.detail.name == "siteLong_sldr")){
            const event = new CustomEvent('COSMOS3_SITE_CHANGE', { detail:{name:"Cosmos3controls_p"} });
            window.dispatchEvent(event);  
        }
        
    }
    private onSliderMouseDown(evt){
        //console.log("in onSliderMouseDown, evt = "+evt.detail.name+", val = "+this.timeSlider_p.value);
        //this.stageSymbol.freeze.visible = true;
        this.universal_rs.uniCamHandler.enableDrag = false;
    }
    private onSliderMouseUp(evt){
        //console.log("in onSliderMouseUp, evt = "+evt.detail.name+", val = "+this.timeSlider_p.value);
        //this.stageSymbol.freeze.visible = false;
        this.universal_rs.uniCamHandler.enableDrag = true;
    }
    /*
    public setZoomSlider(val){
        this.zoomSlider_p.value = val;
        this.universal_rs.uniCamHandler.distance = this.zoomSlider2distance(this.zoomSlider_p.value);
        this.cosmos3_grp.earth.siteLat = this.zoomSlider2lat(this.zoomSlider_p.value); //9 + ((70-10)/(10-1))*this.zoomSlider_p.value; // 1->10, 10->70
         //trace(zoomSlider_mc.value+"  "+const_mc.vScale);
    }
    */
    public set siteLat(val:number){
        //console.log("In cosmos3controls.set siteLat " + val);
        this.siteLat_sldr_p.value = val;
    }
    public get siteLat(){
        return this.siteLat_sldr_p.value;
    }
    public set siteLong(val:number){
        this.siteLong_sldr_p.value = val;
    }
    public get siteLong(){
        return this.siteLong_sldr_p.value;
    } 
   
    public setTimeSlider(val:number){
        if (val == this._timeSliderValue){
            return; // no change
        }
        val = UtilSP.minmax(val, 0, 10);
        if (val <= 0.1){
            this.cosmos3_grp.timeAccelFactor = 0;
        } else {
            // 0.2 -> 1X; 10 ->  3*3600;// Fastest; 3 hour = 1 sec
            this.cosmos3_grp.timeAccelFactor = Math.pow(10,  (val-0.2)*5/10 );
        }
        this.stageSymbol.timeControls.timeScale_txt.text = Math.floor(this.cosmos3_grp.timeAccelFactor)+"X"; ;//Util3.sprintf3("%6.1f", const_mc.tScale)+"X";
        this._timeSliderValue = val;
        this.timeSlider_p.value = this._timeSliderValue;
        //trace(timeSlider_mc.value+"  "+const_mc.tScale);
    }  
    public setTimeSliderX(f:number){
        let v:number = 0.2 + 2 * Math.log10(f);
        //console.log("f = "+f+", v = "+v);
        this.setTimeSlider(v);
    } 
    private onNavButtonDown(evt){
        //console.log("in onNavButtonDown, evt = "+evt.detail.name); // 
        this.navTimer.reset();
    }
    private onNavButtonUp(evt){
        //console.log("in onNavButtonUp, evt = "+evt.detail.name); // 
        this.navTimer.reset();
    }
    public set groupColors(val:Array<string>){
        this._groupColors = val;
    }
     public get groupColors(){
        return this._groupColors;
    } 
    public set groupLabels(val:Array<string>){
        this._groupLabels = val;
    }
     public get groupLabels(){
        return this._groupLabels;
    } 
    public set showAllControls(val:boolean){
        this.stageSymbol.visible = val;
    }      
    public get showAllControls(){
        return this.stageSymbol.visible;
    } 
    public set showTimeControls(val:boolean){
        this.stageSymbol.timeControls.visible = val;
    }
    public get showTimeControls(){
        return this.stageSymbol.timeControls.visible;
    }
    public set showSiteLocationControls(val:boolean){
        this.stageSymbol.siteLocationControls.visible = val;
    }
    public get showSiteLocationControls(){
        return this.stageSymbol.siteLocationControls.visible;
    }  
        
    public set  enableLatLongSliders(val:boolean){
        this._enableLatLongSliders = val;
        this.siteLat_sldr_p.enabled = val;
        this.siteLong_sldr_p.enabled = val;
        this.showSiteLocationControls = val;

    }
    public get enableLatLongSliders(){
        return this._enableLatLongSliders;
    }
}

